module.exports = {
	navList: [],
	navIndexs: [-1, 0, 0, 0]
};
